import React, { useMemo } from 'react';
import * as turf from '@turf/turf';
import { useMapContext } from '@/contexts/MapContext';
import { useSuggestedSudsContext } from '@/contexts/SuggestedSudsContext';
import { markerConfig } from '../markerconfig';
import { SuggestedSudsMarkerAndPopover } from '../SuggestedSudsMarkerContent';

export function SuggestedSudsMarkers({ zIndex }: { zIndex: string }) {
  const { suggestedSudsData, openSuggestedSudsDrawer, setFocusedSuggestedSudsId } =
    useSuggestedSudsContext();
  const { map, mapFilterPolygon, isOptimalMode, isOptimalModeLoaded } = useMapContext();

  const openMoreDetails = (id: number) => {
    setFocusedSuggestedSudsId(id);
    openSuggestedSudsDrawer();
  };

  const onOpenPopover = (id: number) => {
    setFocusedSuggestedSudsId(id);
  };

  const filteredSuds = useMemo(() => {
    if (!isOptimalMode || !isOptimalModeLoaded || !map || !suggestedSudsData || !mapFilterPolygon) {
      return null;
    }
    return (
      <>
        {suggestedSudsData.features.map(
          (
            feature: {
              type: string;
              geometry: { coordinates: any; type: string };
              properties: {
                id: number;
                sudsType: string;
                sudsSubType: string;
                description: string;
                location: string;
                siteType: string;
              };
            },
            index: React.Key | null | undefined
          ) => {
            const point = [
              parseFloat(feature.geometry.coordinates[0]),
              parseFloat(feature.geometry.coordinates[1]),
            ];

            const isInPolygon = turf.booleanPointInPolygon(point, mapFilterPolygon);

            if (isInPolygon) {
              return (
                <SuggestedSudsMarkerAndPopover
                  key={index}
                  map={map}
                  feature={feature}
                  config={markerConfig.suggestedSuds}
                  onOpenPopover={onOpenPopover}
                  openMoreDetails={openMoreDetails}
                  zIndex={zIndex}
                />
              );
            }
            return null;
          }
        )}
      </>
    );
  }, [map, suggestedSudsData, mapFilterPolygon, isOptimalMode, isOptimalModeLoaded]);

  if (!filteredSuds) {
    return null;
  }

  return filteredSuds;
}
